import React, { Fragment, useState } from "react";
import Popup from "../LiveScoreCardpopups/Popup";
import VenueSearch from "../VenueListing/venueSearch";
import { useLocation, useNavigate } from "react-router-dom";
import NewVenueSearch from "../VenueListing/NewVenueSearch";
import { handleLocationClick } from "../Utils/common";

export default function LocationSearch({ isRedirect, packagePage }) {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isEventsPage = location.pathname.includes("/events");
  const userLocation = localStorage.getItem("userLocation")?.split("-")[
    localStorage.getItem("userLocation")?.split("-")?.length - 1
  ];

  const handleSetShow = () => {
    setShow(!show);
  };

  return (
    <Fragment>
      <div
        onClick={() => {
          // event.stopPropagation();
          // handleLocationClick(isEventsPage, null, navigate, handleSetShow, userLocation);
          setShow(true);
        }}
        className="cursor-pointer d-flex align-items-center"
      >
        {" "}
        <img
          src="/images/LocationLatestIcon.svg"
          alt="Location"
          className="me-1"
        />
        {userLocation
          ? userLocation?.charAt(0).toUpperCase() +
            userLocation?.slice(1).toLowerCase()
          : "Choose Location"}
      </div>

      <Popup show={show} onHide={() => setShow(false)}>
        {/* <VenueSearch
          setShow={setShow}
          isRedirect={isRedirect}
          packagePage={packagePage}
          isevent={isEventsPage ? "true" : "false"}
        /> */}
        <NewVenueSearch
          setShow={setShow}
          isRedirect={isRedirect}
          packagePage={packagePage}
          isevent={isEventsPage ? "true" : "false"}
        />
      </Popup>
    </Fragment>
  );
}
